import React from 'react';
import { Text } from 'react-native';

export default function NotFound() {
  return <Text>404: Page not found</Text>;
}
